var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcArowWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "whote_arow_ic") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "whote_arow_ic",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.28,11.7675 L14.73,15.3075 C14.58,15.4565 14.389,15.5275 14.2,15.5275 C14.009,15.5275 13.82,15.4565 13.67,15.3075 C13.38,15.0175 13.38,14.5375 13.67,14.2465 L15.41,12.5175 L5.75,12.5175 C5.34,12.5175 5,12.1775 5,11.7675 C5,11.3475 5.34,11.0175 5.75,11.0175 L15.41,11.0175 L13.67,9.2775 C13.38,8.9875 13.38,8.5075 13.67,8.2175 C13.96,7.9275 14.44,7.9275 14.73,8.2175 L18.28,11.7675 Z",
    id: "Fill-1",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArowWhite);
export default __webpack_public_path__ + "static/media/ic_arow_white.4916e56a.svg";
export { ForwardRef as ReactComponent };